export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full order-2 lg:order-1">
            <div className="relative max-w-[300px] mx-auto">
              <div className="aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-50">
                <img
                  src="https://readdy.ai/api/search-image?query=Mobile%20phone%20showing%20movie%20streaming%20app%20interface%20with%20movie%20posters%20grid%20layout%2C%20warm%20dark%20theme%20with%20golden%20accents%2C%20clean%20modern%20UI%20design%2C%20film%20reel%20icon%2C%20cozy%20atmosphere%2C%20hand%20holding%20phone%20against%20soft%20blanket%20background&width=600&height=1067&seq=app-beiwo&orientation=portrait"
                  alt="被窝网电影移动端观影界面展示"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          <div className="flex-1 w-full order-1 lg:order-2">
            <p className="text-xs font-semibold text-primary-500 tracking-widest uppercase mb-3">Mobile</p>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
              移动观影
            </h2>
            <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
              <p>
                被窝网电影全面支持移动端访问，无需下载安装任何 App，手机浏览器直接打开即可享受与桌面端一致的高清流畅观影体验。
              </p>
              <p>
                无论是通勤路上、午休间隙还是睡前放松，打开被窝网电影官网，海量影视资源随时随地想看就看。横屏全屏播放、手势调节亮度音量，专为移动场景优化。
              </p>
            </div>

            <div className="flex flex-wrap gap-3 mt-8">
              {['浏览器即开即看', '横竖屏自适应', '流量优化', '收藏到桌面'].map((f) => (
                <div key={f} className="flex items-center gap-2 px-4 py-2.5 bg-background-50 border border-background-200/60 rounded-full">
                  <i className="ri-check-line text-accent-500 text-sm"></i>
                  <span className="text-xs font-medium text-foreground-600 whitespace-nowrap">{f}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}